  import {gql} from 'apollo-angular';

export const loginQuery = gql`
  query Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      id
      access_token
      refresh_token
    }
  }
`;
